<div *ngIf="_citofoniaService.modal" class="fondo-negro animated fadeIn" [ngClass]="_realizarLlamadaService.hide">
    <div class="contenedor-modal-bitacora-detalle">
        <div id="modal-llamada-saliente">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header header-verde">
                        <h4 class="modal-title">Citófono</h4>
                        <button type="button" class="close pointer" (click)="_citofoniaService.leaveSession(true)">
                            <img src="assets/images/ico-x.png" />
                        </button>
                    </div>
                    <!-- <div class="name"><p>{{getNicknameTag()}}</p></div> -->

                    <div class="modal-body">
                        <div id="main-container" class="container">
                            <div *ngIf="_citofoniaService.session" id="session">
                                <div id="video-container" class="col-md-12">
                                    <!-- <div id="video-container" class="col-md-5"> -->
                                    <div *ngFor="let sub of _citofoniaService.subscribers">
                                        <!-- <div *ngFor="let sub of _citofoniaService.subscribers" class="stream-container col-md-6 col-xs-6"> -->
                                        <user-video
                                            #videoUser
                                            [streamManager]="sub"
                                            id="user-video"
                                            (click)="_citofoniaService.updateMainStreamManager(sub)"
                                        ></user-video>
                                        <div class="full-screen-btn">
                                            <div class="btn-fulls" (click)="openFullscreen()"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_citofoniaService.loading_make_call">
                            <div class="contenedor-logo">
                                <img src="assets/images/ico-buildin.png" />
                            </div>
                            <div class="titulo-modal-icono-2">Llamando a:</div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-6 centrado-citofonia">
                                        <div class="fondo-a">{{ _realizarLlamadaService.residente }}</div>
                                    </div>
                                    <div class="col-sm-6 centrado-citofonia">
                                        <div class="fondo-b">{{ _realizarLlamadaService.dpto }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="imagen-llamada">
                                <img class="margen-ico-puntos" src="assets/images/circle-modificado.gif" />
                            </div>
                            <div class="texto-llamada">Conectando...</div>
                        </div>
                    </div>

                    <!-- <div class="modal-body" [hidden]="!llamadaActiva">
                        <video #myvideo style="width: 100%; height: 500px;" controls></video>
                    </div> -->

                    <div class="modal-footer alineacion-items">
                        <div class="contenedor-opciones">
                            <button
                                type="button"
                                class="btn btn-modal-cancelar no-margin pointer"
                                (click)="_citofoniaService.leaveSession(true)"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="contenedor-videollamada" *ngIf="!_citofoniaService.modal">
    <div *ngIf="_citofoniaService.session" id="session">
        <div id="video-container">
            <!-- <div id="video-container" class="col-md-5"> -->
            <div *ngFor="let sub of _citofoniaService.subscribers">
                <!-- <div *ngFor="let sub of _citofoniaService.subscribers" class="stream-container col-md-6 col-xs-6"> -->
                <user-video
                    #videoUser
                    [streamManager]="sub"
                    id="user-video"
                    (click)="_citofoniaService.updateMainStreamManager(sub)"
                ></user-video>
                <div class="full-screen-btn">
                    <div class="btn-fulls" (click)="openFullscreen()"></div>
                </div>
            </div>
        </div>
    </div>
</div>
